import React, { Component } from 'react'

class Systemes extends Component {
	constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
	}

	handleChange = event => {
		if( event.target.getAttribute( 'aria-checked' ) === 'true' ) {
			event.target.setAttribute( 'aria-checked', 'false' );
			event.target.innerHTML = 'non';
			this.props.onChange( "systeme" );
		} else {
			event.target.setAttribute( 'aria-checked', 'true' );
			event.target.innerHTML = 'oui';
			this.props.onChange( "systeme" );
		}
  }

	render () {
		return (
			<>
				{ this.props.systemes.map( systeme => (
					<div className="interrupteur-wrap" key={ systeme.id }>
						<button type='button' id={ 'bouton-systeme-' + systeme.id } name='systeme' value={ systeme.id } className='interrupteur' role='switch' aria-checked='true' aria-labelledby={ 'etiquette-systeme-' + systeme.id } onClick={ this.handleChange } aria-controls="nouveautes-contenu">oui</button>
						<span id={ 'etiquette-systeme-' + systeme.id }>{ systeme.name }</span>
					</div>
				) ) }
			</>
		)
	}
}

export default Systemes
